import { useState } from "react";
import Swal from "sweetalert2";
import { SWEETALERT_THEME } from "../../utils/sweetalert-theme";
import logo from "../../assets/scenathon_logo.png";
import { useNavigate } from "react-router-dom";


export default function Step1({ onNext }) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    first_name: "",
    second_name: "",
    last_name: "",
    email: "",
    organization: "",
    country: "ETH",
    password: "",
    confirmPassword: "",
    accepted: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.accepted) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "You must accept the Terms and Conditions.",
        ...SWEETALERT_THEME,
      });
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Passwords do not match.",
        ...SWEETALERT_THEME,
      });
      return;
    }

    const step1Data = {
      first_name: formData.first_name,
      second_name: formData.second_name,
      last_name: formData.last_name,
      email: formData.email,
      organization: formData.organization,
      country: "ETH",
      password: formData.password,
    };

    onNext(step1Data);
  };

  return (
    <div className="relative w-full min-h-screen overflow-hidden bg-[#fafaf0] flex justify-center items-center p-4 md:p-8">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_70%_20%,rgba(187,219,170,0.30),transparent_35%),radial-gradient(circle_at_10%_70%,rgba(255,246,193,0.42),transparent_35%)]" />
      {/* Close button - outside form section */}
        <button
          onClick={() => navigate("/")}
          className="absolute bg-white/45 border border-white/40 backdrop-blur-md top-6 left-6 p-2 text-gray-700 hover:text-gray-900 hover:bg-white/60 rounded-full transition z-10"
          title="Back to Login"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      <div className="bg-white/35 border border-white/40 backdrop-blur-md rounded-2xl shadow-[0_28px_70px_rgba(15,23,42,0.28)] w-full max-w-5xl flex overflow-hidden relative">
        

        {/* Left form section */}
        <div className="w-1/2 p-10 flex flex-col justify-start items-start bg-white/35 backdrop-blur-md">
          <h2 className="text-3xl font-medium mb-4">Create account</h2>

          <form onSubmit={handleSubmit} className="space-y-6 w-full">
            {/* First name */}
            <div className="relative w-full mt-6">
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
                placeholder="First Name"
                className="peer block w-full border-b border-gray-300 bg-transparent text-gray-900 placeholder-transparent focus:outline-none py-2"
              />
              <label
                className="absolute left-0 text-gray-400 text-base 
                top-2 transition-all duration-200
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                peer-focus:-top-4 peer-focus:text-sm peer-focus:text-green-600
                peer-valid:-top-4 peer-valid:text-sm peer-valid:text-green-600
                pointer-events-none"
              >
                First Name
              </label>
            </div>

            {/* Second name (optional) */}
            <div className="relative w-full mt-6">
              <input
                type="text"
                name="second_name"
                value={formData.second_name}
                onChange={handleChange}
                placeholder="Second Name (optional)"
                className="peer block w-full border-b border-gray-300 bg-transparent text-gray-900 placeholder-transparent focus:outline-none py-2"
              />
              <label
                className="absolute left-0 text-gray-400 text-base 
                top-2 transition-all duration-200
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                peer-focus:-top-4 peer-focus:text-sm peer-focus:text-green-600
                peer-[&:not(:placeholder-shown)]:-top-4 peer-[&:not(:placeholder-shown)]:text-sm peer-[&:not(:placeholder-shown)]:text-green-600
                pointer-events-none"
              >
                Second Name (optional)
              </label>
            </div>

            {/* Last name */}
            <div className="relative w-full mt-6">
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
                placeholder="Last Name"
                className="peer block w-full border-b border-gray-300 bg-transparent text-gray-900 placeholder-transparent focus:outline-none py-2"
              />
              <label
                className="absolute left-0 text-gray-400 text-base 
                top-2 transition-all duration-200
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                peer-focus:-top-4 peer-focus:text-sm peer-focus:text-green-600
                peer-valid:-top-4 peer-valid:text-sm peer-valid:text-green-600
                pointer-events-none"
              >
                Last Name
              </label>
            </div>

            {/* Email */}
            <div className="relative w-full mt-6">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="peer block w-full border-b border-gray-300 bg-transparent text-gray-900 placeholder-transparent focus:outline-none py-2"
              />
              <label
                className="absolute left-0 text-gray-400 text-base 
                top-2 transition-all duration-200
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                peer-focus:-top-4 peer-focus:text-sm peer-focus:text-green-600
                peer-valid:-top-4 peer-valid:text-sm peer-valid:text-green-600
                pointer-events-none"
              >
                Email
              </label>
            </div>

            {/* Organization */}
            <div className="relative w-full mt-6">
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                placeholder="Organization"
                className="peer block w-full border-b border-gray-300 bg-transparent text-gray-900 placeholder-transparent focus:outline-none py-2"
              />
              <label
                className="absolute left-0 text-gray-400 text-base 
                top-2 transition-all duration-200
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                peer-focus:-top-4 peer-focus:text-sm peer-focus:text-green-600
                peer-[&:not(:placeholder-shown)]:-top-4 peer-[&:not(:placeholder-shown)]:text-sm peer-[&:not(:placeholder-shown)]:text-green-600
                pointer-events-none"
              >
                Organization
              </label>
            </div>

            {/* Password */}
            <div className="relative w-full mt-6">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                className="peer block w-full border-b border-gray-300 bg-transparent text-gray-900 placeholder-transparent focus:outline-none py-2"
              />
              <label
                className="absolute left-0 text-gray-400 text-base 
                top-2 transition-all duration-200
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                peer-focus:-top-4 peer-focus:text-sm peer-focus:text-green-600
                peer-valid:-top-4 peer-valid:text-sm peer-valid:text-green-600
                pointer-events-none"
              >
                Password
              </label>
            </div>

            {/* Confirm password */}
            <div className="relative w-full mt-6">
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                className="peer block w-full border-b border-gray-300 bg-transparent text-gray-900 placeholder-transparent focus:outline-none py-2"
              />
              <label
                className="absolute left-0 text-gray-400 text-base 
                top-2 transition-all duration-200
                peer-placeholder-shown:top-2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
                peer-focus:-top-4 peer-focus:text-sm peer-focus:text-green-600
                peer-valid:-top-4 peer-valid:text-sm peer-valid:text-green-600
                pointer-events-none"
              >
                Confirm Password
              </label>
            </div>

            <div className="flex items-center gap-3">
              <input
                type="checkbox"
                name="accepted"
                checked={formData.accepted}
                onChange={handleChange}
              />
              <label>
                I agree to{" "}
                <button
                  type="button"
                  onClick={() =>
                    navigate("/terminos", { state: { from: "/registration" } })
                  }
                  className="text-[#C49A1F] hover:text-[#A9821A] font-semibold"
                >
                  Terms and Conditions
                </button>
              </label>
            </div>

            <button
              type="submit"
              className="w-full bg-[#C49A1F] hover:bg-[#A9821A] text-white py-3 rounded-xl transition"
            >
              Register
            </button>
          </form>
        </div>

        {/* Right image section */}
        <div className="w-1/2 relative rounded-r-2xl flex items-center justify-center">
          <div
            style={{
              width: "91%",
              height: "93%",
              background: "rgba(196,154,31,0.42)",
              borderRadius: 12,
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <img
              style={{
                width: 232,
                height: 228,
                objectFit: "contain",
              }}
              src={logo}
              alt="Scenathon logo"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
